import { TableCell, TableRow, Typography } from '@mui/material';
import DataTable from '@/components/DataTable/DataTable';
import FileImportStatusChip from './FileImportStatusChip';
import { formatFileImportLabel } from './fileImportFormatters';

const rowColumns = [
  { key: 'row_number', label: 'Row #', sortable: true },
  {
    key: 'status',
    label: 'Status',
    render: (value) => <FileImportStatusChip value={value} />,
  },
  {
    key: 'action',
    label: 'Action',
    render: (value) => formatFileImportLabel(value),
  },
  { key: 'business_key_type', label: 'Key Type' },
  { key: 'business_key_value', label: 'Source Key' },
  { key: 'normalized_business_key_value', label: 'Normalized Key' },
  { key: 'error_code', label: 'Error Code' },
  { key: 'error_message', label: 'Message' },
];

const rowFilters = [
  {
    key: 'status',
    label: 'Status',
    filterType: 'select',
    options: [
      { value: '', label: 'All statuses' },
      { value: 'successful', label: 'Successful' },
      { value: 'failed', label: 'Failed' },
    ],
  },
  {
    key: 'action',
    label: 'Action',
    filterType: 'search',
    placeholder: 'Filter action',
    debounce: true,
    debounceDelay: 300,
  },
  {
    key: 'error_code',
    label: 'Error Code',
    filterType: 'search',
    placeholder: 'Filter error code',
    debounce: true,
    debounceDelay: 300,
  },
];

const SftpConnectionImportRowsTable = ({
  organizationId,
  connectionId,
  importId,
}) => (
  <DataTable
    key={importId}
    columns={rowColumns}
    endpoint={`/organizations/${organizationId}/sftp-connections/${connectionId}/imports/${importId}/rows`}
    initialSort={{ key: 'row_number', order: 'asc' }}
    pageSize={50}
    autoFetch={true}
    enableColumnPicker={true}
    enableSorting={true}
    enableFilters={true}
    columnFilters={rowFilters}
    renderEmptyState={() => (
      <TableRow>
        <TableCell colSpan={rowColumns.length} align='center' sx={{ py: 6 }}>
          <Typography variant='body1' color='text.secondary'>
            No row outcomes found.
          </Typography>
        </TableCell>
      </TableRow>
    )}
  />
);

export default SftpConnectionImportRowsTable;
